import NotFound from "./not-found.page";

export default NotFound;
